<script setup>
import { defineProps, onMounted, watch, ref } from 'vue';

const props = defineProps({
  /**
   * Src của image
   */
  src: {
    type: String,
    default: '',
  },
});

/**
 * Src hiện tại
 */
const currentSrc = ref(props.src);

/**
 * Lấy avatar mặc định nếu ko lấy đc avatar
 */
const handleError = () => {
  currentSrc.value = require('../../assets/images/icons/ic_avatar-default.svg');
};

watch(
  () => props.src,
  (newVal) => {
    currentSrc.value = newVal;
  }
);

onMounted(() => {
  currentSrc.value = props.src;
});
</script>

<template>
  <img :src="currentSrc" class="image" @error="handleError">
</template>
